<div class="p-support-info">
  <div class="p-support-info__head">
    <h2 class="p-support-info__head-title" [innerHTML]="'label.medicalInformationt' | staticMsg"></h2>
  </div>
  <div class="p-support-info__body">
    <div class="p-support-info__item">
      <div class="p-support-info__item-title" [innerHTML]="'label.doctor' | staticMsg"></div>
      <div class="p-support-info__row">
        <!-- [14.23] 医師の名前 -->
        <asw-input
          maxlength="40"
          [label]="'label.doctorName' | staticMsg"
          [placeholder]="'placeholder.doctorName' | staticMsg"
          [formControl]="doctorNameFc"
          [attr.aria-labelledby]="'reader.doctorName' | staticMsg"
          [conversionType]="'reserveInfo'"
        ></asw-input>
      </div>
      <div class="p-support-info__row">
        <h3 class="p-support-info__row-title" [innerHTML]="'label.telephoneNumber' | staticMsg"></h3>
        <!-- [14.24] 医師の電話番号国 -->
        <asw-select
          [formControl]="phoneCountryCodeFc"
          [label]="'label.countryCode' | staticMsg"
          (change$)="changeCountry($event)"
        >
          <option
            *ngFor="let phoneCountryInfo of master?.phoneCountries"
            [value]="phoneCountryInfo?.country2LetterCode"
            [innerHTML]="phoneCountryInfo?.countryName"
          ></option>
        </asw-select>
      </div>
      <div class="p-support-info__row">
        <!-- [14.25] 医師の電話番号の国番号 & [14.26] 医師の電話番号-->
        <asw-input
          [formControl]="phoneNumberFc"
          [label]="'label.doctorsContact' | staticMsg"
          [placeholder]="'placeholder.doctorsContact' | staticMsg"
          displayType="phone"
          phoneCode="+{{ countryPhoneExtension }}"
          maxlength="16"
          [conversionType]="'phoneNumber'"
          [attr.aria-labelledby]="'reader.doctorsContact' | staticMsg"
        ></asw-input>
      </div>
    </div>
    <div class="p-support-info__item">
      <h3 class="p-support-info__item-title" [innerHTML]="'label.aboutPregnancy' | staticMsg"></h3>
      <div class="p-support-info__row">
        <h3 class="p-support-info__row-title" [innerHTML]="'label.expectedDate' | staticMsg"></h3>
        <div class="p-support-info__row-item">
          <div class="c-form-element-select is-selected">
            <!-- [14.27] 出産予定日 -->
            <asw-select-date-ymd
              order="YMD"
              [dateFrom]="dateFrom"
              [dateTo]="dateTo"
              [initialDate]="{
                year: expectedDateFc.value?.getFullYear(),
                month: expectedDateFc.value ? expectedDateFc.value.getMonth() + 1 : undefined,
                day: expectedDateFc.value?.getDate()
              }"
              (selectedDateChange)="changeExpectedDate($event)"
              [errorMessage]="dueDateError"
              [altLabels]="['reader.scheduleddate.year', 'reader.scheduleddate.month', 'reader.scheduleddate.day']"
            ></asw-select-date-ymd>
          </div>
        </div>
      </div>
      <div class="p-support-info__row">
        <!-- [14.28] 現在の状況 -->
        <asw-select
          [formControl]="conditionFc"
          [label]="'label.currentStatus' | staticMsg"
          [selected]="data?.condition ?? ''"
          [attr.aria-labelledby]="'reader.currentStatus' | staticMsg"
        >
          <option *ngFor="let item of master?.pd020" [value]="item?.value" [innerHTML]="item?.display_content"></option>
        </asw-select>
      </div>
    </div>
    <div class="p-support-info__item">
      <!-- [14.29] 診断書が必要な旨の案内 -->
      <div class="p-support-info__row">
        <div class="p-support-info__attention">
          <em class="p-support-info__attention-text" [innerHTML]="'label.explanationOf Pregnancy' | staticMsg"></em>
        </div>
      </div>
    </div>
  </div>
</div>
